import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/index/Index.vue'
import Product from '@/components/product/Product.vue'
import Programme from '@/components/programme/Programme.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: Index
    },
    {
      path: '/product',
      name: 'product',
      component: Product
    },
    {
      path: '/programme',
      name: 'programme',
      component: Programme
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js